import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, Inject, Optional } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';
import { states } from '@ewarren/unitedstatesofamerica';

@Component({
  selector: 'app-account-settings-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class AccountSettingsCompanyComponent implements OnInit {
  @Output() pending = new EventEmitter<Object>();
  @Output() buttonText = new EventEmitter<String>();

  public companyForm: UntypedFormGroup;
  public statesMappings;
  public updatePending = false;

  constructor(public accountService: AccountService,
    @Optional() @Inject('accountInformation') public accountInformation: any,
    @Optional() @Inject('canAdminister') public canAdminister: boolean
  ) {
    this.createForm();
    this.statesMappings = Object.keys(states).map((s) => { return {abbreviation: s, name: states[s] }; })
  }

  ngOnInit() {
    if(this.accountInformation) {
      this.createForm();
    }
    this.statesMappings = Object.keys(states).map((s) => { return {abbreviation: s, name: states[s] }; })
  }

  async successfulUpdate() {
    this.updatePending = false;
    this.pending.emit({
      is_pending: false,
      message: 'Company successfully updated',
      success: true
    });
  }

  createForm() {    
    if(!this.companyForm && this.accountInformation) {
      let company_info = this.accountInformation && this.accountInformation.company;
      let account_owner_info = this.accountInformation && this.accountInformation.account_owner;
      let address = company_info.address;

      // All fields optional: allow partial updates
      let name = new UntypedFormControl(company_info ? company_info.name : '');
      let line_one = new UntypedFormControl(address ? address.line_one : '');
      let line_two = new UntypedFormControl(address ? address.line_two : '');
      let city = new UntypedFormControl(address ? address.city : '');
      let state = new UntypedFormControl(address ? address.state : '');
      let postal = new UntypedFormControl(address ? address.postal : '');
      let first_name = new UntypedFormControl(account_owner_info ? account_owner_info.name.first_name : '');
      let last_name = new UntypedFormControl(account_owner_info ? account_owner_info.name.last_name : '');

      this.companyForm = new UntypedFormGroup({
        name: name,
        weekly_summary: new UntypedFormControl(false),
        line_one: line_one,
        line_two: line_two,
        city: city,
        state: state,
        postal_code: postal,
        first_name: first_name,
        last_name: last_name
      });
    }
  }

  getStates() {
    return this.statesMappings;
  }

  public save() {
    let form_value = this.companyForm.value
    this.accountService.updateCompanyInfo(this.accountInformation.general.external_id, form_value.name, form_value.weekly_summary, {
      line_one: form_value.line_one,
      line_two: form_value.line_two,
      city: form_value.city,
      state: form_value.state,
      postal: form_value.postal_code
    }, {
      first_name: form_value.first_name,
      last_name: form_value.last_name
    })
        .then((data) => { this.successfulUpdate(); })
        .catch((error) => {
          this.updatePending = false;
          this.pending.emit({
            is_pending: false,
            message: 'Sorry we could not update the company information at this time.',
            success: true
          });
        })

    this.updatePending = true;
  }

  public isValid() {
    // With all-optional fields, the form is valid as soon as it exists
    return !!this.companyForm && this.companyForm.valid;
  }
}
